import { VersionsHistorySidebarState } from './types';
import { ActionTypes, TypeKeys } from './actions';

export const initialState: VersionsHistorySidebarState = {
    contentItemVersionsData: [],
    isFetching: true,
};

export const versionHistorySidebarReducer = (state: VersionsHistorySidebarState = initialState,
    action: ActionTypes): VersionsHistorySidebarState => {
    switch (action?.type) {
    case TypeKeys.CONTENT_ITEM_VERSIONS_DATA_LOADED: {
        return {
            ...state,
            contentItemVersionsData: action.data,
            isFetching: action.isFetching,
        };
    }
    default:
        return {
            ...state,
        };
    }
};
